package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.styles.FormlocalisationStyle
import io.horion.cv.styles.TextFormFieldWhiteStyle
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.Input

@Composable
fun TextFormFieldWhite(
    placeholder: String,
    value: String,
    //enabled: Boolean = false,
    onValueChange: (String) -> Unit,
    modifier: Modifier = TextFormFieldWhiteStyle.toModifier()
){
    Input(
        type = InputType.Text,
        attrs = modifier
            .toAttrs {
                value(value)
                if (placeholder.isNotEmpty()) {
                    attr("placeholder", placeholder)
                }
                /*if (!enabled) {
                    attr("disabled", "")
                }*/

                onInput { event ->
                    //if (enabled) {
                        onValueChange(event.value)
                    //}
                }

            }
    )
}